import { useCallback } from "react";
import { processEnvServer } from "@RHCommerceDev/hooks/useSsrHooks";
import getCountryFromUrl, {
  getLanguageFromUrl
} from "@RHCommerceDev/utils/getCountryFromUrl";
import { useEnv } from "@RHCommerceDev/hooks/useEnv";
import { useDeleteSessionMutation } from "@RHCommerceDev/hooks-mutations";
import useStytch from "@RHCommerceDev/hooks/useStytch";
import Cookies from "universal-cookie";

export function useStytchLogout() {
  const [deleteSession] = useDeleteSessionMutation();
  const env = useEnv();
  const country = getCountryFromUrl();
  const language = getLanguageFromUrl();
  const stytch = useStytch();
  const stytchLogout = useCallback(async () => {
    const cookies = new Cookies();
    const sessionId = cookies.get("stytch_session");
    if (sessionId) {
      await stytch?.session.revoke();
    }
    await deleteSession();
    localStorage.removeItem("isNewUser");
    localStorage.removeItem("isLoggedin");
    if (!processEnvServer && env.REACT_APP_BFF_ORIGIN) {
      window.location.href = `${
        env.REACT_APP_BFF_ORIGIN
      }/${country.toLocaleLowerCase()}/${language.raw}`;
    }
  }, [
    country,
    deleteSession,
    env.REACT_APP_BFF_ORIGIN,
    language.raw,
    stytch?.session
  ]);
  return {
    stytchLogout
  };
}
